import { Component, ErrorInfo, ReactNode } from "react"

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  }

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="registration-container">
          <div className="reg-right-block">
            <h1>Произошла неизвестная ошибка, попробуйте обновить страницу.</h1>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
